module.exports = __webpack_public_path__ + "img/Picture8.9467b908.png";